import { Link } from "react-router-dom";
import { navLinks, siteIntro } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-50 border-t border-primary-100/60">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                榴莲<span className="text-accent-400">视频</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
              {siteIntro.description}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-900/30 px-3 py-1 text-xs text-secondary-900">电影</span>
              <span className="rounded-full bg-secondary-900/30 px-3 py-1 text-xs text-secondary-900">电视剧</span>
              <span className="rounded-full bg-secondary-900/30 px-3 py-1 text-xs text-secondary-900">综艺</span>
              <span className="rounded-full bg-secondary-900/30 px-3 py-1 text-xs text-secondary-900">影视资讯</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wider text-foreground-950">
              <Link to="/" className="hover:text-accent-400 cursor-pointer">内容导航</Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wider text-foreground-950">
              <Link to="/about" className="hover:text-accent-400 cursor-pointer">关于与联系</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                {siteIntro.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-accent-400"></i>
                内容均为演示数据
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400"></i>
                尊重版权，仅供学习
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-100/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 榴莲视频 Durian Video. 保留所有权利。</p>
          <p>本站影视与资讯内容均为演示数据，播放功能仅供界面演示，不提供真实播放服务。</p>
        </div>
      </div>
    </footer>
  );
}